import { DEFAULT_ORDER_SHEET_CONTENT } from "@app/components/editor/workspace/golden-layout-definitions";

import { Component, ViewChild } from "@angular/core";
import { UserService } from "../../services/user.service";
import { User } from "../../data/user";
import { LoaderService } from "../../services/loader.service";
import { fadeInOutAnimation, savingButtonAnimation } from "../../animations";
import { ListingService } from "@app/services/listing.service";

import { Angulartics2 } from "angulartics2";
import { FileService } from "@app/services/file.service";
import { ChangeDetectorRef } from "@angular/core";
import { GoldenLayoutService } from "@app/services/golden-layout.service";
import { BaseEditorComponent } from "@app/components/platform/base-editor.component";
import { CatalogService } from "@app/services/catalog.service";
import { DomSanitizer } from "@angular/platform-browser";
import { Listing } from "@app/data/listing";

@Component({
  templateUrl: "./order-sheet.component.html",
  animations: [fadeInOutAnimation, savingButtonAnimation],
})
export class OrderSheetComponent extends BaseEditorComponent {
  constructor(
    private angulartics2: Angulartics2,
    sanitizer: DomSanitizer,
    catalogService: CatalogService,
    listingService: ListingService,
    userService: UserService,
    loaderService: LoaderService,
    fileService: FileService,
    changeDetectorRef: ChangeDetectorRef,
    goldenLayoutService: GoldenLayoutService
  ) {
    super(
      sanitizer,
      catalogService,
      listingService,
      userService,
      loaderService,
      fileService,
      changeDetectorRef,
      goldenLayoutService
    );
    this.field = "order_sheet";
    this.angulartics2.eventTrack.next({ action: "Opened Order Sheet Page" });
    this.loadCatalogs();
    this.source = "onlineStore";
  }

  protected setUserModel(user: User) {
    user.order_sheet = user.order_sheet || {
      html: "",
      percentage_off: 50,
      is_landscape: true,
      structure: DEFAULT_ORDER_SHEET_CONTENT,
    };
    user.order_sheet.structure =
      user.order_sheet.structure || DEFAULT_ORDER_SHEET_CONTENT;
    super.setUserModel(user);
  }

  protected initDocumentUrl(baseUrl: string) {
    this.documentURL = `${baseUrl}/order-sheet?u=${this.userModel.hashId}&l=`;
  }

  protected initComponent() {
    super.initComponent();
  }

  // protected getPDFURL():string {
  //   return `/api/v2/catalogs/${this.catalog._id}/order-sheet/download`;
  // }

  protected download(): Promise<string> {
    return this.listingService.downloadOrderSheet(this.listings);
  }

  protected applyPercentageOff() {
    var percentageOff = this.userModel.order_sheet.percentage_off || 0;
    this.listings.forEach((listing) => {
      listing.price =
        Math.round(
          (listing.original_price -
            listing.original_price * (percentageOff / 100)) *
            100
        ) / 100;
      if (listing.variations) {
        listing.variations.forEach((variation) => {
          variation.options.forEach((option) => {
            option.price = (
              option.price -
              option.price * (percentageOff / 100)
            ).toFixed(2);
          });
        });
      }
    });
  }

  protected prepareListings() {
    if (this.source === "onlineStore") {
      this.applyPercentageOff();
    }
  }
}
